module.exports = __webpack_public_path__ + "static/media/linkedin-2.5b4e6110.svg";